import {
  getCopyWithContentTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn'
import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      getCopyWithContentTableColumn({
        field: 'id',
        title: i18n.t('scope.text_451'),
      }),
      {
        field: 'billing_account',
        title: i18n.t('scope.text_406'),
        minWidth: 100,
      },
      {
        field: 'type',
        title: i18n.t('scope.text_827'),
        minWidth: 70,
        formatter: ({ row, cellValue }) => {
          const options = {
            redeem: i18n.t('scope.text_935'),
            campaign: i18n.t('scope.text_936'),
            giftcard: i18n.t('scope.text_937'),
            compensation: i18n.t('scope.text_938'),
          }
          return options[cellValue]
        },
      },
      {
        field: 'amount',
        title: i18n.t('scope.text_647'),
        minWidth: 100,
      },
      {
        field: 'min_bill_amount',
        title: i18n.t('scope.voucher_manager.min_bill_amount'),
        minWidth: 100,
      },
      {
        field: 'currency',
        title: i18n.t('scope.text_442'),
        minWidth: 70,
      },
      {
        title: i18n.t('scope.text_512'),
        field: 'notes',
        minWidth: 120,
      },
      getTimeTableColumn({ title: i18n.t('scope.text_828'), field: 'valid_since' }),
      getTimeTableColumn({ title: i18n.t('scope.text_829'), field: 'valid_until' }),
      {
        title: i18n.t('scope.text_426'),
        field: 'status',
        minWidth: 70,
        formatter: ({ cellValue }) => {
          const obj = {
            valid: i18n.t('scope.text_799'),
            redeemed: i18n.t('scope.text_939'),
            cancelled: i18n.t('scope.text_523'),
          }
          return obj[cellValue]
        },
      },
    ]
  },
}
